import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle, Zap } from "lucide-react";

const WARNING_THRESHOLD = 0.8;

export default function SlotLimitBanner({ user }) {
    const [slots, setSlots] = useState(null);

    useEffect(() => {
        if (!user || user.role !== "agenzia" || user.plan_id !== "premium" || !user.plan_active) return;
        (async () => {
            try {
                const { data } = await api.get("/agency/listing-slots/status");
                setSlots(data);
            } catch (e) { /* piano non attivo o richiesta non applicabile: nasconde il banner */ }
        })();
    }, [user]);

    if (!slots || slots.unlimited || slots.is_partner) return null;
    const { used, total_limit } = slots;
    if (!total_limit || used / total_limit < WARNING_THRESHOLD) return null;

    const atLimit = used >= total_limit;
    const remaining = Math.max(0, total_limit - used);

    const scrollToSlots = () => {
        document.querySelector('[data-testid="partnership-card"]')?.scrollIntoView({ behavior: "smooth", block: "center" });
    };

    return (
        <div
            data-testid="slot-limit-banner"
            className={`mb-8 border p-5 flex flex-wrap items-start gap-4 ${atLimit ? "border-red-500/40 bg-red-900/10" : "border-amber-600/40 bg-amber-900/10"}`}
        >
            <AlertTriangle size={18} className={`shrink-0 mt-0.5 ${atLimit ? "text-red-300" : "text-amber-300"}`} />
            <div className="flex-1 min-w-[220px]">
                <div data-testid="slot-limit-banner-title" className={`text-sm font-medium ${atLimit ? "text-red-100" : "text-amber-100"}`}>
                    {atLimit
                        ? `Hai raggiunto il limite di ${total_limit} annunci pubblicati manualmente`
                        : `Ti resta${remaining === 1 ? "" : "no"} solo ${remaining} slot di pubblicazione`}
                </div>
                <p className={`text-xs mt-1 ${atLimit ? "text-red-200" : "text-amber-200"}`}>
                    {used} / {total_limit} annunci pubblicati sul piano Agenzia Pro. Aggiungi Slot Extra o attiva un Codice Partner per continuare a pubblicare senza interruzioni.
                </p>
            </div>
            <button
                data-testid="slot-limit-banner-cta"
                onClick={scrollToSlots}
                className="cta-gold px-4 py-2.5 text-xs shrink-0 inline-flex items-center gap-2"
            >
                <Zap size={12} /> Aggiungi Slot
            </button>
        </div>
    );
}
